module.exports = "<div class=\"fave-button\" (click)=\"toggleFave()\" [ngClass]=\"{'active':isSelected()}\"\n  [ngSwitch]=\"isSelected()\" fxLayoutAlign=\" center\">\n  <mat-icon  *ngSwitchCase=\"false\">star_border</mat-icon>\n  <mat-icon  *ngSwitchCase=\"true\">star</mat-icon>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/offer-fave/offer-fave.component.html
// module id = ../../../../../src/app/shared/components/offer-fave/offer-fave.component.html
// module chunks = main